// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basket-screen .circle-button{width:35px;height:35px;border-radius:100%;background:var(--AkGreyscaleBlack);display:flex;align-items:center;justify-content:center;color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
